module.exports = __webpack_public_path__ + "static/media/sistema-provendas.bb9ee395.jpg";